import http from "@/services/http";
import { IQrCodeAuthParams, IQrCodeAuthRes } from "@/types/device";

// 二维码扫码授权
export async function qrCodeAuth(params: IQrCodeAuthParams) {
  return http.post<IQrCodeAuthRes>("/api/auth/scan-login/qrcode/auth", params);
}
